export default __webpack_public_path__ + "static/media/N0007.61dc5f07.png";